

































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import workOrderPO from "@/store/entities/workorder/workorderpo";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import TreeSelect from "@riophae/vue-treeselect";
import { Common } from '@/lib/Common/Guid';
import Util from "@/lib/util";

@Component({
    components: { TreeSelect },
})
export default class EditWorkOrder extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    workOrderPO: workOrderPO = new workOrderPO();
    loading: boolean = false;
    async created() {
        await this.getOrganizations();
        await this.getareaTree();
        this.getItemDetail();
        await this.getmeterlist();
    }
    /**获取工单类型、问题类型、紧急程序 */
    getItemDetail() {
        if (localStorage.getItem("itemdetail") === null) {
            this.$store.dispatch({
                type: "itemdetail/getdetailtolocalstorge",
            });
        }
        let detaillist = JSON.parse(localStorage.getItem("itemdetail"));

        if (detaillist.length > 0) {
            let info = detaillist.filter((p) => {
                return p.itemId == 26;
            });
            this.$data.ordertypelist = [];
            info.forEach((ele) => {
                this.$data.ordertypelist.push({
                    label: ele.name,
                    value: ele.id,
                });
            });
            let pro = detaillist.filter((p) => {
                return p.itemId == 27;
            });
            this.$data.problemtype = [];
            pro.forEach((ele) => {
                this.$data.problemtype.push({
                    label: ele.name,
                    value: ele.id,
                });
            });
            let metert = detaillist.filter((p) => {
                return p.itemId == 28
            });
            this.$data.orderlevel = [];
            metert.forEach((ele) => {
                this.$data.orderlevel.push({
                    label: ele.name,
                    value: ele.id,
                });
            });
        }
    }
    /**获取设备信息 */
    async getdeviceinfo() {
        if (this.workOrderPO.deviceId != null) {
            await this.$store.dispatch({ type: 'meter/get', id: this.workOrderPO.deviceId }).then((val) => {
                if (val != null) {
                    (this.workOrderPO as any) = {
                        deviceId: this.workOrderPO.deviceId,
                        organizationId: val.organizationId,
                        areaId: val.areaId,
                        location: val.location == null ? val.roomNo : val.location,
                        deviceNo: val.meterNo,
                        orderNo: Common.createNo.createNo(),
                        isReserva: false,
                        reservaTime: null,
                    }
                }
            })
        }
    }
    /**保存 */
    save() {
        (this.$refs.workOrderForm as any).validate(async (valid: boolean) => {
            if (valid) {
                this.loading = true;
                if (this.workOrderPO.isReserva && this.workOrderPO.reservaTime == null) {
                    this.$Modal.warning({
                        title: this.L("Tips"),
                        content: "预约时间不能为空",
                    });
                    this.loading = false;
                    return;
                }
                await this.$store
                    .dispatch({
                        type: "workorder/update",
                        data: this.workOrderPO,
                    })
                    .then((val) => {
                        if (val.data.success == true) {
                            this.$Modal.info({
                                title: this.L("Tips"),
                                content: this.L("Success"),
                            });
                            this.loading = false;
                            (this.$refs.workOrderForm as any).resetFields();
                            this.$emit("save-success");
                            this.$emit("input", false);
                        }
                        this.loading = false;
                    })
                    .catch(() => {
                        this.loading = false;
                    });
                //this.loading = false;

            }
        });
    }
    /**退出 */
    cancel() {
        (this.$refs.workOrderForm as any).resetFields();
        this.workOrderPO.deviceId = Common.Guid.MakeNew().ToString();
        this.$emit("input", false);
    }

    /**获取组织 */
    async getOrganizations() {
        await this.$store
            .dispatch("organization/getselectTree")
            .then((val) => {
                this.$data.organizations = val;
            })
            .catch((err) => {
                console.log(err);
            });
    }
    /**获取区域 */
    async getareaTree() {
        await this.$store
            .dispatch("area/getAreaSelectTree")
            .then((val) => {
                this.$data.arealist = val;
            })
            .catch((err) => {
                console.log(err);
            });
    }
    /**获取设备列表 */
    async getmeterlist() {
        await this.$store
            .dispatch("meter/meterSelectList")
            .then((val) => {
                this.$data.deviceList = val;
            })
            .catch((err) => {
                console.log(err);
            });
    }
    /**窗体可见 */
    visibleChange(value: boolean) {
        this.workOrderPO = Util.extend(
            true,
            {},
            this.$store.state.workorder.editWorkOrder
        );
    }
    /**验证规则 */
    validRules = {
        deviceId: [
            {
                required: true,
                message: this.L("PleasChoose"),
                trigger: "blur",
            },
        ],
        title: [
            {
                required: true,
                message: this.L("FieldIsRequired"),
                trigger: "blur",
            },
        ],
        problemTypeId: [
            {
                type: 'number',
                required: true,
                message: this.L("PleasChoose"),
                trigger: "blur",
            },
        ],
        orderLevelId: [
            {
                type: 'number',
                required: true,
                message: this.L("PleasChoose"),
                trigger: "blur",
            },
        ],
        orderTypeId: [
            {
                type: 'number',
                required: true,
                message: this.L("PleasChoose"),
                trigger: "blur",
            },
        ],
        contacts: [
            {
                required: true,
                message: this.L("FieldIsRequired"),
                trigger: "blur",
            },
        ],
        mobile: [
            {
                required: true,
                message: this.L("FieldIsRequired"),
                trigger: "blur",
            },
        ],
        description: [
            {
                required: true,
                message: this.L("FieldIsRequired"),
                trigger: "blur",
            },
        ],
    };
    data() {
        return {
            optionsMechanism: [],
            organizations: [],//组织
            arealist: [],//区域
            ordertypelist: [],//工单类型
            orderlevel: [],//工单等级
            problemtype: [],//问题类型
            deviceList: [],//设备列表
            normalizer(node) {
                if (node.children && !node.children.length) {
                    delete node.children;
                }
                return {
                    id: node.id,
                    label: node.label,
                    children: node.children,
                };
            },
        };
    }
}
